var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 882.2 249.1",
    style: {
      enableBackground: "new 0 0 882.2 249.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FF5000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173.4,77.4v95.8h-20V133h-43.4v40.2h-20V77.4h20v38.1h43.4V77.4H173.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M248.3,150.4c-2.5,14.8-13.4,24.3-30.9,24.3c-20.3,0-33.9-14.8-33.9-36.3c0-21.1,14-36.5,33.5-36.5    c20.4,0,31.7,14.2,31.7,34.6v5.9h-46.5c0.6,10.5,6.6,16.7,15.1,16.7c6.6,0,11.4-2.8,12.9-8.7H248.3z M202.7,130.8h27    c-0.2-7.3-4.5-13.1-12.5-13.1C209.7,117.7,204.4,122.2,202.7,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M267.6,94.4c-6.2,0-11.5-4.5-11.5-11.1c0-6.4,5.3-11.1,11.5-11.1c6.1,0,11.4,4.7,11.4,11.1    C279,89.9,273.7,94.4,267.6,94.4z M277.3,173.2h-19.3v-69.7h19.3V173.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.8,101.9c14.4,0,22.9,10,22.9,25.7v45.6h-19.3v-41.5c0-7.5-3.3-12.5-10-12.5c-5,0-9.5,3.1-10.8,9v44.9    h-19.5v-41.5c0-7.5-3.1-12.5-9.8-12.5c-5,0-9.7,3.1-10.9,9v44.9H291v-69.7h19.3v5.8c3.4-4.4,9.8-7.3,17.6-7.3    c8.3,0,14.8,3.7,18.7,8.9C351.2,105.8,357.9,101.9,367.8,101.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.3,152.5c1.6,5,5.9,7.6,11.7,7.6c5.9,0,9.8-2.3,9.8-6.9c0-3.1-2.2-4.7-7-5.9l-14-3.1    c-10.6-2.5-18.1-8-18.1-19.7c0-13.6,12.2-22.6,27.8-22.6c17.6,0,27.3,8.4,29.6,21.5h-18.4c-1.2-3.9-4.5-6.9-10.9-6.9    c-4.7,0-9.2,2.2-9.2,6.6c0,2.8,1.9,4.4,6.2,5.5l14.4,3.3c12.2,3,18.6,9.7,18.6,20.3c0,14.2-12.3,22.6-28.5,22.6    c-17,0-29-8.1-31-22.3H418.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.9,119.1h-10.6v-15.6h10.6V84.6h19.2v18.9h15.3v15.6h-15.3v30.6c0,5.5,3,8,8,8c3,0,6.2-0.9,8.4-2.3v17.2    c-2.7,1.4-7.3,2.2-12.5,2.2c-14.2,0-23.1-7-23.1-22.5V119.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M557,173.2v-3.7c-2.3,2.3-9.4,5-17,5c-14,0-25.9-8.1-25.9-22.6c0-13.3,11.9-22.3,27-22.3    c6.1,0,13.1,2,15.9,4.1v-5.1c0-5.9-3.6-10.8-11.4-10.8c-5.5,0-8.7,2.5-10.3,6.6h-18.4c2-12.6,13.4-22.3,29.3-22.3    c18.6,0,29.3,10.1,29.3,26.8v44.5H557z M557,149.2c-1.7-3.7-7-6.1-12.6-6.1c-6.1,0-12.3,2.7-12.3,8.6c0,6.1,6.2,8.6,12.3,8.6    c5.6,0,10.9-2.3,12.6-6.1V149.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M632.9,167.4c-3.1,3.7-10,7.3-17.5,7.3c-20.3,0-31.7-16.4-31.7-36.3c0-20,11.4-36.5,31.7-36.5    c7.5,0,14.4,3.6,17.5,7.3V71.8h19.5v101.4h-19.5V167.4z M632.9,126.9c-2.2-4.7-7.5-8.1-13.1-8.1c-10.5,0-16.7,8.4-16.7,19.7    c0,11.1,6.2,19.5,16.7,19.5c5.8,0,10.9-3.3,13.1-8.1V126.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M726.4,150.4c-2.5,14.8-13.4,24.3-30.9,24.3c-20.3,0-33.9-14.8-33.9-36.3c0-21.1,14-36.5,33.5-36.5    c20.4,0,31.7,14.2,31.7,34.6v5.9h-46.5c0.6,10.5,6.6,16.7,15.1,16.7c6.6,0,11.4-2.8,12.9-8.7H726.4z M680.8,130.8h27    c-0.2-7.3-4.5-13.1-12.5-13.1C687.8,117.7,682.5,122.2,680.8,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M736,103.5h19.3v6.4c3.7-4.4,10.6-8,18.7-8c15.8,0,24.6,10.3,24.6,25.7v45.6h-19.3v-41.5    c0-7.3-3.7-12.3-11.4-12.3c-5.9,0-11.1,3.6-12.6,9.7v44.1H736V103.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1efd9dd9.svg";
export { ForwardRef as ReactComponent };